module.exports = do ->
   React = require("react")
   classNames = require("classnames")
   {div, label, span} = ReactLibs.DOMFactories
   {createFactory} = require("base/new-utils")
   HelpTip = createFactory require("components/tooltip/helptip").default

   FormField = ReactLibs.createClass
      displayName: "FormField"
      propTypes:
         label: ReactLibs.PropTypes.any.isRequired
         align: ReactLibs.PropTypes.oneOf ["top", "middle"]
         inlineLabel: ReactLibs.PropTypes.bool
         helpKey: ReactLibs.PropTypes.string
         required: ReactLibs.PropTypes.bool
         requiredLabelSize: ReactLibs.PropTypes.string
         boldLabel: ReactLibs.PropTypes.bool
         centerLabel: ReactLibs.PropTypes.bool
         disabledRequired: ReactLibs.PropTypes.bool
         testId: ReactLibs.PropTypes.string
         useDiv: ReactLibs.PropTypes.bool

      getDefaultProps: ->
         align: "top"
         inlineLabel: true
         required: false
         disabledRequired: false
         requiredLabelSize: ""
         boldLabel: false
         centerLabel: false
         useDiv: false

      render: ->
         unless @props.align == "top"
            align_class = "is-aligned-#{@props.align}"

         div className: classNames(@props.className, "form-field", align_class, "is-label-top": !@props.inlineLabel),
            if @props.useDiv then div className: classNames("form-field--label", "bold-text": @props.boldLabel, "form-field--label--centered": @props.centerLabel),
               span className: "form-field--label-wrap", "data-testid": @props.testId,
                  @props.label 
                  if @props.required then span className: classNames("form-field--required", @props.requiredLabelSize, {"form-field--required-disabled": @props.disabledRequired}), "Required"
                  if @props.helpKey
                     HelpTip
                        help_key: @props.helpKey
                        position: "right"
            else label htmlFor: @props.for, className: classNames("form-field--label", "bold-text": @props.boldLabel, "form-field--label--centered": @props.centerLabel),
               span className: "form-field--label-wrap", "data-testid": @props.testId,
                     @props.label 
                     if @props.required then span className: classNames("form-field--required", @props.requiredLabelSize, {"form-field--required-disabled": @props.disabledRequired}), "Required"
                     if @props.helpKey
                        HelpTip
                           help_key: @props.helpKey
                           position: "right"
            div className: "form-field--control",
               @props.children